export var LogLevels;!function(L){L.DEBUG="DEBUG",L.LOG="LOG",L.INFO="INFO",L.WARN="WARN",L.ERROR="ERROR"}(LogLevels||(LogLevels={}));